import React from "react";
import InfoTooltip from "../../../../components/common/InfoTooltip";
import CustomSelect, {
  OptionType,
} from "../../../../components/form/CustomSelect";

export const postDelayHoursOptions: OptionType[] = [
  {
    value: null,
    label: "-",
    description: "",
  },
  ...Array.from({ length: 24 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
    description: "",
  })),
];

interface PostDelayHourSelectorProps {
  postDelayHours: number | null;
  onChange: (value: number | null) => void;
}

const PostDelayHourSelector = ({
  postDelayHours,
  onChange,
}: PostDelayHourSelectorProps) => {
  return (
    <div className="flex flex-col gap-1">
      <label
        htmlFor="post-delay-hours-1"
        className="flex gap-2 items-center uppercase text-xs tracking-wide font-medium leading-6 text-gray-900"
      >
        Post Delay Hours
        <InfoTooltip
          id="post-delay-hours"
          tooltip="The number of hours to wait before posting the article."
        />
      </label>
      <div className="text-[0.825rem] leading-5 text-gray-500">
        Select the number of hours to delay publishing.{" "}
        <div className="">
          Example: If the run time is 2:00 PM and you select 6 hours, the post
          will be published at 8:00 PM.
        </div>
      </div>
      <div className="text-xs text-gray-600"></div>
      <CustomSelect
        label="Hours"
        placeholder="-"
        className="max-w-[7rem]"
        maxMenuHeight={200}
        isClearable={Boolean(postDelayHours)}
        options={postDelayHoursOptions}
        selected={postDelayHoursOptions.find(
          (option) => option.value === postDelayHours
        )}
        setSelected={(option) => {
          onChange(option?.value ?? null);
        }}
      />
    </div>
  );
};

export default PostDelayHourSelector;
